(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-welcome-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPopup(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dialog = root.querySelector('[data-dc-dialog]');
    const teaser = root.querySelector('[data-dc-teaser]');
    const closeButtons = root.querySelectorAll('[data-dc-close]');
    const copyButton = root.querySelector('[data-dc-copy]');
    const code = root.querySelector('[data-dc-code]');
    const success = root.querySelector('[data-dc-success]');
    const error = root.querySelector('[data-dc-error]');
    const form = root.querySelector('form');

    if (!dialog || !teaser) return;

    const storageBase = 'dcWelcomePopupV2';
    const subscribedKey = storageBase + ':subscribed';
    const dismissedKey = storageBase + ':dismissedAt';
    const sessionTeaserKey = storageBase + ':teaserThisVisit';
    const suppressDays = Number(root.dataset.suppressDays || 14);
    const suppressMs = suppressDays * 24 * 60 * 60 * 1000;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const delay = Number(isMobile ? root.dataset.mobileDelay : root.dataset.desktopDelay) || (isMobile ? 10000 : 8000);
    const testMode = false; // normale popupregels actief

    function getStored(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }

    function setStored(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) {}
    }

    function getSession(key) {
      try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
    }

    function setSession(key, value) {
      try { window.sessionStorage.setItem(key, value); } catch (e) {}
    }

    function clearSession(key) {
      try { window.sessionStorage.removeItem(key); } catch (e) {}
    }

    function hideTeaser() {
      teaser.dataset.visible = 'false';
      teaser.hidden = true;
    }

    function showTeaser() {
      teaser.dataset.visible = 'true';
      teaser.hidden = false;
    }

    hideTeaser();

    function consentBannerVisible() {
      const selectors = ['#shopify-pc__banner', '.shopify-pc__banner__dialog', '[data-shopify-privacy-banner]', '.cookie-banner'];
      return selectors.some(function (selector) {
        const element = document.querySelector(selector);
        if (!element) return false;
        const style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
      });
    }

    function openPopup(force) {
      if (dialog.open) return;
      if (!force && consentBannerVisible()) {
        window.setTimeout(function () { openPopup(false); }, 1500);
        return;
      }
      hideTeaser();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');

      const email = dialog.querySelector('input[type="email"]');
      if (email && !success) {
        window.setTimeout(function () { email.focus({ preventScroll: true }); }, 80);
      }
    }

    function handleClosed() {
      if (success) {
        hideTeaser();
        return;
      }
      setStored(dismissedKey, String(Date.now()));
      setSession(sessionTeaserKey, '1');
      showTeaser();
    }

    function closePopup() {
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      else {
        dialog.removeAttribute('open');
        handleClosed();
      }
    }

    if (testMode) {
      hideTeaser();
      window.setTimeout(function () { openPopup(true); }, delay);
    } else if (success) {
      setStored(subscribedKey, '1');
      clearSession(sessionTeaserKey);
      hideTeaser();
      openPopup(true);
    } else if (error) {
      openPopup(true);
    } else if (getStored(subscribedKey) === '1') {
      clearSession(sessionTeaserKey);
      hideTeaser();
    } else {
      const dismissedAt = Number(getStored(dismissedKey) || 0);
      if (dismissedAt && Date.now() - dismissedAt < suppressMs) {
        if (getSession(sessionTeaserKey) === '1') showTeaser();
        else hideTeaser();
      } else {
        clearSession(sessionTeaserKey);
        let delayReady = false;
        let interacted = false;
        let opened = false;

        function maybeOpen() {
          if (opened || !delayReady || !interacted) return;
          opened = true;
          openPopup(false);
        }

        function markInteraction() {
          interacted = true;
          maybeOpen();
        }

        window.setTimeout(function () {
          delayReady = true;
          maybeOpen();
        }, delay);

        window.addEventListener('pointerdown', markInteraction, { once: true, passive: true });
        window.addEventListener('keydown', markInteraction, { once: true });
        window.addEventListener('scroll', markInteraction, { once: true, passive: true });

        window.setTimeout(function () {
          if (!opened) {
            opened = true;
            openPopup(false);
          }
        }, delay + (isMobile ? 8000 : 6000));
      }
    }

    closeButtons.forEach(function (button) { button.addEventListener('click', closePopup); });
    dialog.addEventListener('close', handleClosed);
    teaser.addEventListener('click', function () { openPopup(true); });

    if (form) {
      form.addEventListener('submit', function () {
        const submit = form.querySelector('button[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
        }
      });
    }

    if (copyButton && code) {
      copyButton.addEventListener('click', function () {
        const value = code.textContent.trim();
        const copiedLabel = copyButton.dataset.copiedLabel || 'Copied';

        function done() {
          copyButton.textContent = copiedLabel;
          window.setTimeout(function () {
            copyButton.textContent = copyButton.dataset.copyLabel || 'Copy';
          }, 1600);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = value;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
          done();
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-dc-welcome-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
